import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cart:[]
}

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers:{
        addToCart: (state, action) => {
            const item = action.payload;
            const existingItem = state.cart.find(cartItem => cartItem.id === item.id && cartItem.size === item.size)
            if(existingItem){
                if(existingItem.quantity < existingItem.totalQuantity){
                existingItem.quantity += 1
            }
            }else{
                if(item.quantity <= item.totalQuantity){
                state.cart.push(item);
                alert("item successfully added to cart")
              }else{
                alert("minimum quantity must be 1")
              }   
            }
        },
        removeFromCart: (state, action) => {
            const { id, size} = action.payload;
            state.cart = state.cart.filter(
                item => !(item.id === id && item.size == size)
            )
        },
        clearCart: (state) =>{
            state.cart = [];
        },
        updateQuantity: (state, action) => {
            const { id, size} = action.payload;
            const item = state.cart.find(
                item => item.id === id && item.size === size
            )
            if(!item) return

            if(item.quantity < item.totalQuantity){
                item.quantity += 1
            }
        },
         reduceQuantity: (state, action) => {
            const { id, size} = action.payload;
            const item = state.cart.find(
                item => item.id === id && item.size === size
            )
            if(!item) return

            if(item.quantity > 1){
                item.quantity -= 1
            }
        }
    }
})

export const {
    addToCart, removeFromCart, clearCart, updateQuantity, reduceQuantity
} = cartSlice.actions;

export default cartSlice.reducer;